import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  changeClientLoadingState,
  dispatch,
  setClientState,
  setErrorMessage,
  setSuccessMessage,
  addClientState,
  setClientBlockData,
  setClientReportById,
  deleteClientState,
  clientsummary,
  clientPerformaceSummary,
  clientSummary,
  setSelectedYear,
  setYearOptions,
} from "../redux";

export const createClientService = async (formData) => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.createClientAccount, {
      ...formData,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addClientState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeClientLoadingState(false));
  }
};

export const getClients = async (
  refresh = false,
  page,
  limit,
  search = "",
  sort,
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getClients, {
      params: {
        page,
        limit,
        search,
        sort,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setClientState({ clients: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeClientLoadingState(false));
  }
};
export const getClientBlockData = async (id, block) => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(
      ApiEndpoints.getclientBlockById + "/client/" + id + "/block/" + block,
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setClientBlockData(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.result;
  } catch (error) {
    // Set Error message to store
    // dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeClientLoadingState(false));
  }
};
export const getClientsWithStatus = async (
  refresh = false,
  page,
  limit,
  search = "",
  year,
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(
      ApiEndpoints.getClientsWithFitnessStatus,
      {
        params: {
          page,
          limit,
          name: search,
          year,
        },
      },
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setClientState({ clients: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeClientLoadingState(false));
  }
};

export const getClientReportById = async (id) => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(
      ApiEndpoints.getClientReportsByClientId + "/" + id,
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }
    // Update to Store
    dispatch(setClientReportById(resp.data.results));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeClientLoadingState(false));
  }
};

export const updateClientReportByClientId = async (id, formData) => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().patch(
      ApiEndpoints.updateClientReportByReportId + "/" + id,
      { ...formData },
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addClientState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.result;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeClientLoadingState(false));
  }
};

export const deleteClient = async (id) => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().delete(
      ApiEndpoints.deleteClient + "/" + id,
    );
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(deleteClientState(id));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};

export const getClientSummary = async () => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.clientSummary);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(clientSummary(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};
export const getPerformanceSummary = async () => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.clientPerformanceSummary);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(clientPerformaceSummary(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};

export const getClientReportPdf = async (clientId) => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().get(
      ApiEndpoints.clientReportSummaryDownload + "/" + clientId,
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    // dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};
export const getClientReportPdfSend = async (clientId) => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().patch(
      ApiEndpoints.clientReportSummarySent + "/" + clientId,
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};

//reset year
export const resetYear = async (year) => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));

    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.resetYear, {
      year: year,
    });
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    dispatch(setSelectedYear(year));
    dispatch(setSuccessMessage(resp.data.message));

    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};
export const getYearOptions = async () => {
  try {
    // Set Loading
    dispatch(changeClientLoadingState(true));
    const resp = await httpClient().get(ApiEndpoints.getYearOptions);

    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }
    const { result, results } = resp.data;

    // Normalize different possible response shapes into an array of years
    let years;

    if (Array.isArray(results)) {
      // Future shape: { results: [...] }
      years = results;
    } else if (Array.isArray(result)) {
      // Future shape: { result: [...] }
      years = result;
    } else if (Array.isArray(result?.years)) {
      // Possible shape: { result: { years: [...] } }
      years = result.years;
    } else if (Array.isArray(result?.year)) {
      // Possible shape: { result: { year: [...] } }
      years = result.year;
    } else if (typeof result?.year !== "undefined") {
      // Current shape: { result: { year: 2025 } }
      years = [result.year];
    } else if (typeof result !== "undefined") {
      // Fallback: treat single value as one-element array
      years = [result];
    } else {
      years = [];
    }

    dispatch(setYearOptions(years));
    dispatch(changeClientLoadingState(false));
    return years;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
    dispatch(changeClientLoadingState(false));
  }
};

export const sendAllClientsReport = async () => {
  try {
    dispatch(changeClientLoadingState(true));
    const resp = await httpClient().patch(ApiEndpoints.sendAllClientsReport);

    if (!resp.data.success && resp.status >= 201) {
      throw new Error(resp.data.message);
    }

    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(setErrorMessage(error.message));
  }
};
